import { isFunction } from '#lib/utils/function.js';
import React from 'react';
import { KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

export function useDragAndDrop({
    onDragStart: providedOnDragStart,
    onDragEnd: providedOnDragEnd,
    onDragCancel: providedOnDragCancel
}) {
    const [draggedItemId, setDraggedItemId] = React.useState();

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 4
            }
        }),
        useSensor(TouchSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );

    const onDragStart = React.useCallback((event) => {
        const { active } = event;
        if (isFunction(providedOnDragStart)) providedOnDragStart(active);
        setDraggedItemId(active.id);
    }, []);

    function onDragEnd(event) {
        const { active, over } = event;
        if (isFunction(providedOnDragEnd)) providedOnDragEnd(active, over);
        setDraggedItemId(null);
    }

    const onDragCancel = React.useCallback(() => {
        if (isFunction(providedOnDragCancel)) providedOnDragCancel();
        setDraggedItemId(null);
    }, []);

    return {
        draggedItemId,
        sensors,
        onDragStart,
        onDragEnd,
        onDragCancel
    };
}
